export const TEXT_INPUT_TYPES = {
  EMAIL: 'email',
  PASSWORD: 'password',
  SEARCH: 'search',
  TEXT: 'text',
  URL: 'url',
  NUMBER: 'number'
};
export const LEFT_PADDING = 12;
export const RIGHT_PADDING = 12;
export const ICON_SIZE = 20;
//# sourceMappingURL=consts.js.map